module.exports = __webpack_public_path__ + "static/media/text-image.caf0c1d1.png";